import LegalLayout from "@/pages/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Obchodné podmienky" lastUpdated="9. február 2026">
      <p className="lead">
        Tieto obchodné podmienky upravujú používanie webovej aplikácie{" "}
        <strong>Real Selfie</strong> dostupnej na adrese{" "}
        <a href="https://realselfie.eu">realselfie.eu</a> (ďalej len &bdquo;Služba&ldquo;).
        Používaním Služby súhlasíte s týmito podmienkami.
      </p>

      <h2>1. Prevádzkovateľ</h2>
      <p>
        <strong>František Varga – VFN</strong>
        <br />
        IČO: 54 175 488
        <br />
        Sídlo: Malé Blahovo, Horná 1694/43, 929 01 Dunajská Streda, Slovenská
        republika
        <br />
        E-mail: <a href="mailto:support@realselfie.eu">support@realselfie.eu</a>
        <br />
        (ďalej len &bdquo;Prevádzkovateľ&ldquo;)
      </p>
      <p>
        Prevádzkovateľ je zapísaný v Živnostenskom registri SR. Nie je platcom DPH.
        Dohliadací orgán: Slovenská obchodná inšpekcia, Inšpektorát SOI pre
        Trnavský kraj.
      </p>

      <h2>2. Predmet služby</h2>
      <p>
        Real Selfie je webová aplikácia (Progressive Web App), ktorá umožňuje
        zachytávať selfie fotografie bez zrkadlového efektu — fotka zachytí
        reálny obraz tváre tak, ako ju vidia ostatní. Aplikácia obsahuje aj
        filtre, časovač, prednú &bdquo;blesk&ldquo; funkciu, nastavenia pomeru strán a
        lokálnu galériu.
      </p>

      <h2>3. Bezplatná verzia a Premium</h2>
      <ul>
        <li>
          <strong>Bezplatná verzia</strong>: každé zariadenie môže bez platby
          zachytiť 3 fotografie. Funkcie ako galéria, filtre a časovač sú v
          bezplatnej verzii dostupné v plnom rozsahu pre tieto fotografie.
        </li>
        <li>
          <strong>Premium</strong>: jednorazová platba <strong>1,29 €</strong>{" "}
          odomkne neobmedzené fotografie a všetky súčasné aj budúce Premium
          funkcie pre dané zariadenie. Premium licencia je viazaná na
          identifikátor zariadenia (anonymný UUID generovaný v prehliadači),
          nie na účet ani osobu.
        </li>
        <li>
          Cena je konečná. Prevádzkovateľ nie je platcom DPH, faktúra po
          platbe je vystavená automaticky cez systém Stripe.
        </li>
      </ul>

      <h2>4. Platba a poskytovatel platobných služieb</h2>
      <p>
        Platby spracováva spoločnosť{" "}
        <strong>Stripe Payments Europe, Ltd.</strong> (Írsko). Prevádzkovateľ
        nemá prístup k údajom o platobnej karte zákazníka — tie sú spravované
        výhradne v systéme Stripe.
      </p>
      <p>
        Po úspešnej platbe je Premium licencia okamžite aktivovaná pre dané
        zariadenie. V prípade technického problému s aktiváciou kontaktujte{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a>.
      </p>

      <h2>5. Právo na odstúpenie od zmluvy</h2>
      <p>
        Podľa § 7 ods. 6 písm. l) zákona č. 102/2014 Z. z. o ochrane spotrebiteľa
        pri predaji tovaru alebo poskytovaní služieb na základe zmluvy uzavretej
        na diaľku, spotrebiteľ <strong>nemôže odstúpiť od zmluvy</strong>,
        ktorej predmetom je poskytovanie elektronického obsahu (digitálnej
        funkcionality), ak bolo poskytovanie elektronického obsahu začaté pred
        uplynutím lehoty na odstúpenie a spotrebiteľ s tým výslovne súhlasil a
        vyhlásil, že bol riadne poučený o strate práva na odstúpenie.
      </p>
      <p>
        <strong>Súhlas</strong>: Zakliknutím tlačidla &bdquo;Odomknúť za 1,29 €&ldquo;
        výslovne súhlasíte s okamžitým poskytnutím digitálneho obsahu a beriete
        na vedomie, že tým strácate právo na odstúpenie od zmluvy podľa § 7
        ods. 6 písm. l) cit. zákona.
      </p>
      <p>
        <strong>Nad rámec zákona</strong>: Ak ste s aplikáciou nespokojní z
        technického dôvodu (napr. Premium sa neaktivuje, aplikácia nefunguje
        podľa popisu), môžete do 14 dní od platby požiadať o vrátenie peňazí
        zaslaním e-mailu na{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a> s
        opisom problému. Vrátenie posúdime individuálne.
      </p>

      <h2>6. Technické požiadavky a obmedzenia</h2>
      <ul>
        <li>
          Aplikácia vyžaduje moderný prehliadač s podporou kamery
          (`getUserMedia` API) a HTTPS pripojenia.
        </li>
        <li>
          Premium licencia je viazaná na zariadenie a prehliadač. Vymazaním
          dát prehliadača (localStorage) môžete o Premium status prísť. V
          takom prípade nás kontaktujte — pomôžeme s obnovou.
        </li>
        <li>
          Fotografie sa ukladajú lokálne v zariadení používateľa (v
          prehliadači cez IndexedDB a vo vybranom priečinku zariadenia).
          Prevádzkovateľ nemá k týmto fotografiám prístup.
        </li>
      </ul>

      <h2>7. Zodpovednosť</h2>
      <p>
        Služba je poskytovaná &bdquo;tak ako je&ldquo;. Prevádzkovateľ vyvinul primerané
        úsilie, aby zabezpečil dostupnosť a funkčnosť Služby, nezodpovedá však
        za škodu spôsobenú nemožnosťou používať Službu, stratu dát z
        používateľského zariadenia ani za nepriame či následné škody.
      </p>
      <p>
        Tieto obmedzenia neplatia v prípade úmyslu alebo hrubej nedbanlivosti
        Prevádzkovateľa a v prípadoch, kde to nepripúšťa kogentná právna
        úprava na ochranu spotrebiteľa.
      </p>

      <h2>8. Riešenie sporov</h2>
      <p>
        V prípade sporu sa môžete obrátiť na Prevádzkovateľa cez e-mail{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a>.
      </p>
      <p>
        Ako spotrebiteľ máte právo na alternatívne riešenie sporu (ARS) podľa
        zákona č. 391/2015 Z. z. Subjektom ARS je{" "}
        <strong>Slovenská obchodná inšpekcia</strong> (
        <a href="https://www.soi.sk" target="_blank" rel="noopener noreferrer">
          www.soi.sk
        </a>
        ). Spor môžete riešiť aj online cez platformu{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
        >
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2>9. Zmeny podmienok</h2>
      <p>
        Prevádzkovateľ si vyhradzuje právo tieto podmienky meniť. Aktuálna
        verzia je vždy dostupná na adrese{" "}
        <a href="https://realselfie.eu/terms">realselfie.eu/terms</a>. Zmeny
        nadobúdajú účinnosť dňom zverejnenia a nevzťahujú sa spätne na už
        uzavreté objednávky.
      </p>

      <h2>10. Rozhodné právo</h2>
      <p>
        Zmluvný vzťah sa riadi právnym poriadkom Slovenskej republiky. Súdom
        príslušným pre prípadné spory je vecne a miestne príslušný súd v
        Slovenskej republike.
      </p>
    </LegalLayout>
  );
}
